export default "/images/vendor/flag-icon-css/flags/1x1/mw.svg?83c32d57b8256fb3a1fe204adb67981f";